import { useMemo } from 'react';

import { AGE, AGE_MAP } from '@/entities/public-filter/constants';
import type { DemographicStat } from '../../../../entities/post/models';
import type { TableColumnConfig } from '../../../../shared/components/data-table';
import { DataTable } from '../../../../shared/components/data-table';
import { TableHeader } from './table-header';

interface Props {
  ageData: DemographicStat[];
  onAgeClick?: (age: DemographicStat, event: React.MouseEvent) => void;
  isLoading?: boolean;
}

export function AgeTable({ ageData, onAgeClick, isLoading }: Props) {
  const sortedAgeData = useMemo(() => ageData, [ageData]);

  const columns = useMemo(
    (): TableColumnConfig<DemographicStat>[] => [
      {
        key: 'name',
        header: 'Age',
        size: 'auto',
        cell: ({ getValue }) => (
          <DataTable.Cell
            getValue={() => {
              const value = getValue();
              return AGE_MAP.get(value as AGE) ?? '';
            }}
          />
        ),
      },
      {
        key: 'postCount',
        header: 'Volume',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalViews',
        header: 'Views',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalLikes',
        header: 'Likes',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalShares',
        header: 'Shares',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalComments',
        header: 'Comments',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
    ],
    [],
  );

  const handleAgeClick = (age: DemographicStat, event: React.MouseEvent) => {
    onAgeClick?.(age, event);
  };

  return (
    <DataTable
      data={sortedAgeData}
      header={<TableHeader title="Age" />}
      columns={columns}
      onRowClick={handleAgeClick}
      pageSize={10}
      minHeight="200px"
      isLoading={isLoading}
    />
  );
}

// const AGE_ORDER = ['1-9', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-'] as const;

// function sortAgeData(ageData: DemographicStat[]): DemographicStat[] {
//   return [...ageData].sort((a, b) => {
//     const aIndex = AGE_ORDER.indexOf(a.name as (typeof AGE_ORDER)[number]);
//     const bIndex = AGE_ORDER.indexOf(b.name as (typeof AGE_ORDER)[number]);

//     if (aIndex === -1 && bIndex === -1) return 0;
//     if (aIndex === -1) return 1;
//     if (bIndex === -1) return -1;

//     return aIndex - bIndex;
//   });
// }
